export type LanguageCode = 'en' | 'es';

export const SUPPORTED_LANGUAGES: readonly LanguageCode[] = ['en', 'es'];

export const DEFAULT_LANGUAGE: LanguageCode = 'en';

export const isSupportedLanguage = (value: string): value is LanguageCode =>
  (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
